import { useMoedas } from "./use-moedas";
import { MoedasView } from "./view-moedas";

export function MoedasScreen() {
  const vm = useMoedas();

  return <MoedasView {...vm} />;
}

export type * from "./types-moedas";
